import useAppGuard from "./useAppGuard";

export const AppGuard = ({ children, checkSubscription = true }) => {
  const { grantAccess } = useAppGuard({ checkSubscription });

  return grantAccess ? children : null;
};
